import React from "react";
import AddClaim from "../../components/views/AddClaim";
import firebase from "../../../services/firebase";

const DB = firebase.db;

class AgregarReclamosCliente extends React.Component {
    constructor(props) {
        super();
        this.state = {
            loader: false,
        };
        this.handleClick = this.handleClick.bind(this);

    }

    componentDidMount() {
        window.scrollTo(0, 0);

    }

    handleClick(type) {
        if (type === "add") {
            //agregar accion de proveedores.
        }
    }

    render() {
        return (
            <div>
                <AddClaim
                    loader={this.state.loader}
                    screenSize={window.screen.width}
                    handleClick={this.handleClick}
                />
            </div>
        );
    }
}

//export default connect(mapStateToProps, mapDispatchToProps)(PropiedadesCliente);

export default AgregarReclamosCliente;
